<template>
  <RestaurantElistmentForm :typeEndPoint="'restaurantElistmentForm'" :dataParams="{}"/>
</template>
<script>
import RestaurantElistmentForm from '@/components/modules/restaurant/enlistment/form'
export default {
  name: 'RestaurantElistmentCreate',
  components: {
    RestaurantElistmentForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/enlistment/create.vue